<template>
  <div class="animated fadeIn">
    <b-card v-if="!partner && model && model.id">
      <h5 block>
      {{model.permissions || '-'}}
      Partner : {{model.username || '-'}}
      <span class="pull-right">
        {{model.nickname || '-'}}
      </span>
      </h5>
    </b-card>
    <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
      <b-tab :title="partner || (model && model.id) ? 'Partner' : 'Partner Generation'" border-variant="primary" >
        <div class="d-flex flex-wrap align-items-center">
          <div class="title mr-auto">
            Partner Information
          </div>
          <div class="mb7">
            <span class="pull-right" v-if="!add && model.created_at">Joined_at  : {{model.created_at | datetime}}</span>
          </div>
        </div>
        <hr>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label label="Allow login" label-for="ph_use" v-b-tooltip.hover title="Allow login.">
              Allow login
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock" />
              <div class="checkbox-animate">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-col>
          <b-col class="col-xl-2 col-md-12  d-flex align-self-center">
            <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="Permission.">Permissions</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <v-select :disabled="model && !model.parent_id" v-if="!lock" label="text" v-model="model.permissions" :options="codes.permissions_partner"></v-select>
            <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.id">
            <label class="col-form-label">Last_visit</label>
          </b-col>
          <b-col class="col-xl-10 col-md-12  d-flex align-self-center" v-if="model.id">
              {{model.last_visit | datetime}} @ {{model.last_addr}}
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-else>
            <label class="col-form-label" v-if="model && !model.parent_id">
              Partner Group connect
              <small>If the partner being created belongs to the same group as the other partner</small>
            </label>
            <label class="col-form-label" v-else>Partner Group : {{model.parent_username}}</label>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="!model.id">
            <b-button class="btn btn-sm margin_t col-md-12 mr-2" variant="primary" @click="partner_connect_modal = true" block>Search</b-button>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.parent_id && model.parent_id != model.id && lock">
            <label class="col-form-label" for="">Partner Group Owner</label>
          </b-col>
          <b-col class="col-xl-10 col-md-12  d-flex align-self-center" v-if="model.parent_id && model.parent_id != model.id && lock">
            <label>{{model.parent_username}}</label>
            <b-button v-show="!(model.parent_id && model.parent_id == model.id)" variant="primary" @click="reload" block>View</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="Username">
              Username(ID)
              <span class="text-danger ml-1">*</span>
              <span v-if="model.is_del" class="text-danger">Deleted user, Logging in is not possible even if you allow it.</span>
              <b-badge v-if="model && model.id && model.parent_id"  :variant="model.parent_id && model.parent_id == model.id ? 'success' : 'primary'">
                * Partner Group {{model.parent_id && model.parent_id == model.id ? ' Master' : 'Member'}}
              </b-badge>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
            <b-form-input :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock" ></b-form-input>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_nickname">
              Nick Name
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
            <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-show="add || !lock">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_pass">
              {{add ? 'User' : 'Change'}} Password
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
            <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
              Min Length : 10
            </b-badge>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.new_password">
            <label class="col-form-label" for="ph_pass2">
              Password Repeat
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12" v-if="model.new_password">
            <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" label="Invoice Email Notice" v-b-tooltip.hover title="Sets whether issued invoice is sent or not. Only 'Owner' accounts can be set.">
              Invoice Email Notice
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="Invoice_Email_Notice" :disabled="lock || model.parent_id && model.parent_id != model.id" v-model="model.allow_invoice" />
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_tax">Tax : [%]</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <b-form-input type="number" id="ph_tax" v-model="model.tax" :plaintext="lock"></b-form-input>
          </b-col>
        </b-row>
        <br>
        <div class="d-flex flex-wrap align-items-center">
          <div class="title_sub">
            Region
          </div>
        </div>
        <hr>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_country_group" v-b-tooltip.hover title="country">
              Country
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <v-select :readonly="true" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_language_group" v-b-tooltip.hover title="language">
              language
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <v-select :readonly="true" label="name" :disabled="lock" v-model="region.language" :options="codes.language"></v-select>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_timezone_group" v-b-tooltip.hover title="Timezone">
              Timezone
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <v-select :readonly="true" label="name" :disabled="lock" v-model="region.timezone" :options="codes.timezone" ></v-select>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_address" v-b-tooltip.hover title="Address for billing">
              Address
              <span class="text-danger ml-1">*</span>
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12">
            <b-form-input type="text" id="ph_address" v-model="model.address" :plaintext="lock"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row class="mb-2">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">
              List of allowed IPs
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex  flex-wrap align-self-center">
            <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="">
              <span class="text-danger ml-1">*</span>
              The logo is using when Invoice
            </label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <img v-if="lock" class="text-center" height="120" width="330" :src="model.logo || 'img/F1-uwss.png'" alt="Hello, F1security">
            <b-form-group v-else>
              <!-- v-show="!confirm_save && !confirm_refresh" -->
              <picture-input
                :z-index="2"
                radius="3"
                :prefill="model.logo"

                ref="pictureInput"
                height="140" min-height="150" width="600"  max-width="600" max-height="200"
                accept="image/*" size="2" button-class="btn btn-dark"
                :custom-strings="{
                  upload: '<h1>uploading</h1>',
                  drag: '<small>Drag & Drop<small>',
                }"
                @change="logo_change">
              </picture-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
      </b-tab>
    </b-tabs>
    <router-view></router-view>
  </div>
</template>

<style>
.g {
  /* width: 33px; */
  height: 100%;
}

/* .nav-tabs .nav-link{
  border-color : #c8ced3
} */
</style>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>